
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Join the ultimate cruise party experience in Goa, where vibrant music, stunning views, and delicious cuisine come together for an unforgettable night on the water. Perfect for friends, celebrations, and special occasions.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the best cruise party offerings in Goa, featuring lively entertainment, breathtaking sunset views, and a festive atmosphere that makes for an ideal party backdrop with friends and family.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Set sail for an exhilarating cruise party in Goa, where you can dance the night away, enjoy gourmet dining, and take in the scenic beauty of the coastline. A must for party lovers and celebrations!',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'cruise party goa, new year cruise party goa, goa cruise party, nightlife goa cruise party, goa cruise party price',
        },
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'Cruise Party in Goa - Night Cruise Party in Goa',
    };
  },


  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/cruise-party-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/cruise-party-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/cruise-party-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Cruise Party in Goa - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Dinner Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/cruise-party-goa",
        "url": "https://www.goa.app/cruise-party-goa",
        "name": "Cruise Dinner in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.602Z4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Me3ndUchwTkA6cGwKpW8CcOMum53gFRdXiiJad8DnQTB8C0JjrjffodVz2QYbA1BWcNG1bDtUkP7wGJXQ737z%2BCl2P40KMLutqvfWODVdHMiHapVzRqnvMMUgq%2F%2FkZOpZYgQSRd2UDfvIOg2aOYbqYVq24W9KHnsX4rKCPg4oRM9WZptOxaQBrly4i6qEgn7Aq3lXmggvQ3b9sgixALyZteBa8zd%2B4vtrXm0LJANKPIh7SgUL8Z3FMlFb5ZcF9LVV4KkD0exFg1FxYPcvE0L5K%2Bw2HQjdpxCtW6tNsHvvMbvMQOshHktiZhadg3R3u%2F3SJWVwjA%2BTAuIPw5pJr0Ymw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Cruise Party Goa offers a memorable experience with scenic views, lively entertainment, and great vibes. Ideal for celebrations or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while partying along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/cruise-party-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/cruise-party-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a cruise party dinner in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a cruise party dinner in Goa through various online platforms or by contacting local operators. Be sure to book in advance during peak season to secure your spot."
  }
},
{
  "@type": "Question",
  "name": "What is included in a cruise party dinner package?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "A typical cruise party dinner in Goa includes a multi-course meal, live entertainment, and scenic views of the coastline. Some packages also include beverages and additional activities."
  }
},
{
  "@type": "Question",
  "name": "What should I wear to a cruise party dinner in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It’s recommended to dress in smart casual attire for a cruise party dinner. Avoid flip-flops and beachwear, and opt for comfortable yet elegant outfits."
  }
},
{
  "@type": "Question",
  "name": "How long does a cruise party dinner in Goa last?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Cruise party dinners in Goa typically last around 2 to 3 hours, depending on the package and type of cruise. Some premium packages may offer extended experiences."
  }
},
{
  "@type": "Question",
  "name": "Can I customize the menu for a cruise party dinner?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some operators allow customization of the menu for special occasions, especially for private bookings. It's best to check with the cruise provider in advance."
  }
},
{
  "@type": "Question",
  "name": "Is live entertainment available on a cruise party dinner?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, most cruise party dinner packages in Goa feature live music, dance performances, or DJs to enhance the dining experience while cruising."
  }
},
{
  "@type": "Question",
  "name": "What is the price range for a cruise party dinner in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The price for a cruise party dinner in Goa ranges from ₹2,000 to ₹5,000 per person, depending on the type of cruise and inclusions such as drinks and entertainment."
  }
},
{
  "@type": "Question",
  "name": "Can I book a private cruise party dinner for special occasions?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators offer private cruise party dinner packages for special occasions like birthdays, anniversaries, or corporate events. Contact the provider for customization options."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to go on a cruise party dinner in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time for a cruise party dinner in Goa is during the evening, around sunset. This provides the perfect ambiance with stunning views and cooler weather."
  }
},
{
  "@type": "Question",
  "name": "Are cruise party dinners available throughout the year in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Cruise party dinners are available year-round in Goa, but the best time is between November and February when the weather is most pleasant for evening cruises."
  }
},
{
  "@type": "Question",
  "name": "Do cruise party dinners in Goa accommodate dietary preferences?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Many cruise operators offer vegetarian and non-vegetarian options. If you have specific dietary preferences or allergies, it's advisable to inform the operator when booking."
  }
}

        ]
      }
    ]
  };
},

};


  